/**
 * @file linkText.js
 * @description Tiny helper for pages that split a paragraph into before / link / after i18n keys.
 *   The text that follows a link normally needs one leading space, but a translation may start with
 *   punctuation (".", ",", ":") so that the sentence can end right after the link. This keeps the
 *   English output byte-for-byte the same while letting other languages place punctuation freely.
 * @module lib/linkText
 */

/** Prefix a single space to the text that follows an inline link, unless it starts with punctuation. */
export function afterLink(text) {
  const s = String(text == null ? "" : text);
  return /^[.,;:!?)]/.test(s) ? s : ` ${s}`;
}
